import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import { Box, Chip, Typography } from '@mui/material';
import React, { FunctionComponent } from 'react';
import { L3ServiceViewModel } from '../../model';

interface Props {
  l3Service: L3ServiceViewModel;
}

export const L3ServiceNotificationsButton: FunctionComponent<Props> = ({ l3Service }) => {
  return <Box sx={{ width: 72 }} role="alert">{l3Service.notificationsQuantity > 0 &&
    <Chip icon={<NotificationsNoneOutlinedIcon color="warning" />}
          label={<Typography sx={{ fontWeight: 600 }}>{l3Service.notificationsQuantity}</Typography>}
          variant="outlined"
    />}
  </Box>;
};
